import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BathtubIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bathtub"}/>
}
